<script>
export default {
  name: 'LoadingRing',
};
</script>

<template lang="pug">
i.loading-ring.h2.w2.relative.db

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
@keyframes loadingAnimation {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.loading-ring {
  &:before {
    content: "";
    position: absolute;
    width: 50px;
    height: 50px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 6px solid #fff;
    opacity: .2;
  }
  &:after {
    content: "";
    z-index: 1;
    position: absolute;
    width: 50px;
    height: 50px;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    border-width: 6px;
    border-style: solid;
    border-color: var(--green) transparent var(--green) transparent;
    animation: loadingAnimation 1.3s linear infinite;
  }
}
</style>
